import { environment } from '../../../environments/environment';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  AfterViewChecked,
} from '@angular/core';
import { SharedService } from '@services/shared/shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-table-content',
  templateUrl: './table-content.component.html',
  styleUrls: ['./table-content.component.scss'],
})
export class TableContentComponent implements OnInit, AfterViewChecked {
  @Input() headingOrder: string[] = [];
  @Input() itemOrdername: string[] = [];
  @Input() itemList: Record<any, any>[] = [];

  @Input() showLocation: boolean = false;
  @Input() dtOptions: any = null;
  public dtOptions2: any = {};
  @Input() navigateToEdit: string = '';
  @Input() navigateToView: string = '';
  @Input() actionKeys: ['view' | 'edit' | 'delete' | null] = [null];
  @Input() inAuction: boolean = false;
  @Output() emmitItemId: EventEmitter<string> = new EventEmitter<string>();
  @Output() removeItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() productIdAndStatus: EventEmitter<object> =
    new EventEmitter<object>();

  public imgBaseUrl: string = '';
  public env: string = environment.forntend_url;
  public updateLoader: boolean[] = [];
  public updateLoaderIndex: number = null;
  public navigateId = null;

  constructor(private sharedService: SharedService, private router: Router) {
    this.dtOptions2 = {
      dom: 'Bfrtip',
      buttons: [
        {
          extend: 'excel',
          text: 'Export Excel',
        },
      ],
      pageLength: 10,
    };
  }

  ngOnInit(): void {
    this.updateLoadingStatus();
  }

  ngAfterViewChecked(): void {
    this.getProductImage();
  }

  viewProduct = (id: string, index: number) => {
    this.emmitItemId.next(id);

    if (this.itemList.length) {
      if (
        this.itemList[index]['buy_status'] &&
        this.itemList[index]['buy_status'] === '0'
      ) {
        this.navigateId = this.itemList[index]['product_id'];
        this.router.navigate([`${this.navigateToView}${this.navigateId}`]);
      } else if (
        this.itemList[index]['buy_status'] &&
        this.itemList[index]['buy_status'] !== '0'
      ) {
        this.navigateId = this.itemList[index]['payment_uuid'];
        this.router.navigate([`${this.navigateToView}${this.navigateId}`]);
      } else {
        this.navigateId = this.itemList[index]['auction_id'];
        this.router.navigate([`${this.navigateToView}${this.navigateId}`]);
      }
    }
  };

  removeVehicleItem(index: number, id: string) {
    this.removeItem.next({ index, id });
  }

  updateStatus(productId: string, status: boolean, index: number) {
    const idAndStatus = { productId, status, index };
    this.updateLoader[index] = true;
    this.updateLoaderIndex = index;

    this.productIdAndStatus.next(idAndStatus);
  }

  getProductImage(): void {
    if (this.itemList.length) {
      this.itemList.forEach((product, index) => {
        if (product?.['type'] === '3' || product?.['type'] === '1') {
          this.imgBaseUrl = environment.imgBaseUrl;
        } else if (product?.['type'] === '2') {
          this.imgBaseUrl = environment.auctionBaseUrl;
        }

        let frontImg = '';

        if (
          product?.['vehicle_images']?.['parts_images'] &&
          product['vehicle_images']['parts_images'].length
        ) {
          for (
            let i = 0;
            i < product['vehicle_images']['parts_images'].length;
            i++
          ) {
            if (
              product['vehicle_images']['parts_images'][i]?.['part_name'] ===
              'Front'
            ) {
              frontImg =
                this.imgBaseUrl +
                product['vehicle_images']['parts_images'][i]['image'];
              break;
            }
          }
        } else if (product?.['productImageUrl']?.[0]?.['presigned_url']) {
          frontImg = product['productImageUrl'][0]['presigned_url'];
        } else if (product?.['imageUrl']?.[0]?.['presigned_url']) {
          frontImg = product['imageUrl'][0]['presigned_url'];
        } else {
          frontImg = this.env + 'assets/img/car-placeholder.png';
        }
        this.itemList[index].frontImg = frontImg;
      });
    }
  }

  updateLoadingStatus() {
    this.sharedService.isLoading.subscribe((res) => {
      if (res) {
        this.updateLoader[this.updateLoaderIndex] = false;

        this.itemList[this.updateLoaderIndex]['description_data']['Status'] =
          !this.itemList[this.updateLoaderIndex]['description_data']['Status'];
      }
    });
  }
}
